import React, {Fragment} from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {
    AddressFormatter,
    CurrencyFormatter,
    OptionFormatter,
    remoteComponentFormatter,
    remoteOptionFormatter, SignedCurrencyFormatter
} from "../../../utils/formatters";
import {componentFilter, optionFilter} from "../../../utils/filters";
import Confirm from "../../form/Confirm";
import {postData} from "../../../utils/request";
import Icon from "src/components/form/Icon";

class paymentList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading, pageSize} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: pageSize || 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "paymentList"}
                {...props}
                aggregations={{
                    fields: {
                        "total": {
                            field: "total", type: "SUM"
                        }
                    }
                }}
                columns={{
                    [componentConfig.idfield]: {
                        header: 'Tranz. sz.',
                        width: 2,
                        sortable,
                        filterable
                    },
                    "total": {
                        header: 'Összeg',
                        width: 2,
                        sortable,
                        filterable,
                        renderer: SignedCurrencyFormatter,
                        className: "currency"
                    },
                    "serviceprovider_type": {
                        header: 'Fizetés módja',
                        width: 2,
                        sortable,
                        operator: "=",
                        filterable: componentFilter({component: "PaymentServiceProvider", labelfield: "methodname"}),
                        renderer: (value) => <div className="nowrap">{remoteComponentFormatter({component: "PaymentServiceProvider", labelfield: "methodname"})(value)}</div>
                    },
                    "state": {
                        header: 'Állapot',
                        width: 2,
                        sortable,
                        operator: "=",
                        filterable: optionFilter("PaymentStatus"),
                        //filterable: optionFilter("KhStatus"),
                        renderer: (value, row) => remoteOptionFormatter("PaymentStatus")(value)
                    },
                    "status": {
                        header: 'Státusz',
                        width: 2,
                        sortable,
                        operator: "=",
                        //filterable: optionFilter("KhStatus"),
                        renderer: (value, row) => remoteOptionFormatter(row.serviceprovider_type + "Status")(value)
                    },
                    "created_at": {
                        header: "Létrehozás időpontja",
                        width: 2
                    },
                    "actions": {
                        header: ' ',
                        width: 'cell-button',
                        renderer: (value, rowData) => {
                            if (rowData.total < 0 && rowData.state + "" === "0") {
                                return <Confirm
                                    body="Biztos lemond róla?"
                                    acceptButton="Igen"
                                    icon={{lib: "fa", name: "money-bill-wave"}}
                                    color="warning"
                                    size="xs"
                                    tooltip="Lemond róla"
                                    onAccept={async () => await this.props.processAction(async () => {
                                        return await postData({
                                            action: componentConfig.componentname + '.disclaim',
                                            [componentConfig.idfield]: rowData[componentConfig.idfield]
                                        });
                                    })}
                                />;
                            }
                            return null;
                        }
                    },
                }}
                rowClassName={(rowData) => {
                    if (this.props.stateType.completed(rowData.state)) {
                        return {"success": true};
                    } else if (this.props.stateType.pending(rowData.state)) {
                        return {"warning": true};
                    }
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default paymentList;
